export default "__VITE_ASSET__Ayr7OBxL__"